import { cn } from '~/shadcn/lib/utils'

export const BlurredContent = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('select-none blur-[3px]', className)} {...props} />
)
